import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

const Header = () => {
  const navigate = useNavigate()
  
  const goToApp = () => {
    navigate('/app')
  }

  return (
    <motion.header 
      className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container-max">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <img 
              src="/images/emdrplus-logo eye.png" 
              alt="EMDR Plus Logo" 
              className="w-16 h-16 object-contain"
            />
            <div className="flex items-baseline space-x-1">
              <span className="text-xl font-bold text-gray-900">EMDR</span>
              <span className="text-xl font-normal text-gray-600">Plus</span>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center space-x-4">
            <button 
              onClick={goToApp}
              className="btn-primary"
            >
              Lancer une séance
            </button>
          </div>
        </div>
      </div>
    </motion.header>
  )
}

export default Header 